import { databases } from "@/lib/appwrite";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const TRAVELS_COLLECTION_ID = import.meta.env.VITE_TRAVELS_REQUESTS_COLLECTION_ID;


//  para aprobar una solicitud de viaje

export async function approveTravel(travelId: string, approvedByUserId: string) {
    try {
        const updatedTravel = await databases.updateDocument(
            DATABASE_ID,
            TRAVELS_COLLECTION_ID,
            travelId,
            {
                status: "approved",
                statusByRrhh: "approved",
                idApprovedByRrhh: approvedByUserId,
                idRejectedByRrhh: null, 
                commentByRrhh: null
            }
        );

        return {
            success: true,
            data: updatedTravel,
        };
    } catch (error) {
        console.error("Error approving travel:", error);
        throw error;
    }
}


//  Rechazar una solicitud de viaje

export async function rejectTravel(
    travelId: string,
    rejectedByUserId: string,
    comment: string
) {
    try {
        const updatedTravel = await databases.updateDocument(
            DATABASE_ID,
            TRAVELS_COLLECTION_ID,
            travelId,
            {
                status: "rejected",
                statusByRrhh: "rejected",
                idApprovedByRrhh: null,
                idRejectedByRrhh: rejectedByUserId,
                commentByRrhh: comment
            }
        );

        return {
            success: true,
            data: updatedTravel,
        };
    } catch (error) {
        console.error("Error rejecting travel:", error);
        throw error;
    }
}